import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import PercentageLabel from "../../frameworks/components/PercentageLabel";
import AttackTechnique from "./AttackTechnique";

const AttackTactic = ({
  title,
  applicable = true,
  percentage,
  techniques,
  showNA,
  onTechniqueClick,
  showRisk,
  isHistoricalView,
}) => {
  const [filteredTechniques, setFilteredTechniques] = useState([]);
  const filterTechniques = (techniques, showNA) => {
    return techniques.filter((technique) => showNA || technique.applicable);
  };
  const colors = useColors();

  useEffect(() => {
    let filterted = filterTechniques(techniques, showNA);
    setFilteredTechniques(filterted);
  }, [showNA, techniques]);

  return (
    <Paper
      sx={{
        height: "100%",
        padding: 2,
        width: "332px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        backgroundColor: colors.common_white,
        border: `1px solid ${colors.icon_stroke}`,
        boxShadow: "none",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography variant="body2" color={colors.text_primary}>
            {filteredTechniques.length}
          </Typography>
          <Typography variant="subtitle2" color={colors.text_primary}>
            {title}
          </Typography>
        </Box>
        <PercentageLabel
          applicable={applicable}
          percentage={applicable ? percentage : 0}
          tooltipTitle={
            showRisk
              ? "Percentage of relevant entities currently at risk from this technique"
              : "Percentage of relevant entities compliant with this technique out of the total number of relevant entities"
          }
          negativePercentage={showRisk}
        />
      </Box>

      {filteredTechniques.map((technique, index) => (
        <AttackTechnique
          key={index}
          technique={technique}
          onTechniqueClick={onTechniqueClick}
          showRisk={showRisk}
          isHistoricalView={isHistoricalView}
        />
      ))}
    </Paper>
  );
};

export default AttackTactic;
